module.exports = __webpack_public_path__ + "img/dsFiltro.6fd964a1.svg";